import type { GetAppointmentsParams } from "@/Modules/Models/Api/Schedule";
import type { Appointment } from "@/Modules/Models/Domain/Schedule";
import { useScheduleStore } from "@/Modules/Schedule/Store";

import AppointmentTransformer from "@/Modules/Transformers/Appointment";

import { getAppointments } from "@/Services/TherapyApi/Schedule";

import { log } from "@/Utils/Debug";

const GetAppointmentsActionHandler = async (
  appointmentsParams?: GetAppointmentsParams
): Promise<Appointment[]> => {
  const scheduleStore = useScheduleStore();

  scheduleStore.isLoading = true;

  await getAppointments(appointmentsParams)
    .then((res) => {
      scheduleStore.appointments = res.map(AppointmentTransformer.toDomain);
    })
    .catch((e) => {
      log("Error get schedule", e);

      scheduleStore.appointments = [];
    })
    .finally(() => {
      scheduleStore.isLoading = false;
    });

  return scheduleStore.appointments!;
};

export default GetAppointmentsActionHandler;
